import { useLocation } from "@/lib/router-compat";
import { useEffect, useState, type ReactNode } from "react";

/**
 * Wraps page content in a subtle fade/slide-in animation triggered by route
 * changes. Gives the impression of a smooth, polished transition while heavy
 * route chunks finish hydrating — masking perceived loading time.
 */
export const PageTransition = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();
  const [key, setKey] = useState(pathname);

  useEffect(() => {
    setKey(pathname);
  }, [pathname]);

  return (
    <div key={key} className="animate-fade-in">
      {children}
    </div>
  );
};
